import {
  formatCountdown,
  parseCountdownDate,
  startCountdown,
} from "@lyle/countdown";

class LyleCountdown extends HTMLElement {
  #stop = null;

  connectedCallback() {
    const display = this.querySelector("[data-countdown-display]");
    if (!display) return;

    const endDate = parseCountdownDate(this.dataset.endDate);
    if (!endDate) return;

    const hideWhenEnded = this.dataset.hideWhenEnded === "true";
    const endedMessage = this.dataset.endedMessage || "";

    this.#stop = startCountdown(
      endDate,
      (timeLeft) => {
        this.dataset.state = "running";
        display.textContent = formatCountdown(timeLeft);
      },
      () => {
        this.dataset.state = "ended";

        if (hideWhenEnded) {
          this.hidden = true;
          return;
        }

        display.textContent = endedMessage || formatCountdown(0);
      },
    );
  }

  disconnectedCallback() {
    this.#stop?.();
    this.#stop = null;
  }
}

if (!customElements.get("lyle-countdown")) {
  customElements.define("lyle-countdown", LyleCountdown);
}
